{
  "de": {
    "lot": {
      "attributes": {
        "end_date": "Enddatum",
        "internal_note": "Interne Notiz zum Grundstück",
        "land_register": "Grundbuch",
        "name": "Name",
        "start_date": "Startdatum",
        "surface": "Fläche"
      },
      "labels": {
        "lot": "Kein Grundstück | Ein Grundstück | {count} Grundstücke"
      },
      "toasts": {
        "create": "Grundstück wurde erstellt",
        "delete": "Grundstück wurde gelöscht",
        "update": "Grundstück wurde aktualisiert"
      },
      "validation": {
        "needName": "Titel ist erforderlich",
        "needNumber": "Muss eine Zahl sein (z. B. 85)"
      }
    }
  }
}
